export function chapterText(chapter: number): string {
  return String(chapter).padStart(2, "0")
}

export type AtaCode = {
  ata_chapter: number | null
  ata_subchapter: number | null
  ata_zone: number | null
}
